import { IMessage, MessageFile } from '@common/hooks/useGptConversation';
import React from 'react';
import {
  Dimensions,
  Image,
  Linking,
  Text,
  Touchable,
  TouchableHighlight,
  TouchableOpacity,
  View,
} from 'react-native';
import { getUrlRegex } from '../../ChatComponent/hook';
import { useGptConversationContext } from '../../../GptConversation/context';
import createStyles from './style';
import { isImageFile } from '../../shared';

type Props = { message: IMessage; styles: ReturnType<typeof createStyles> };

const formatUrl = (url: string) => {
  if (url.length <= 30) return url;
  const firstPart = url.substring(0, 20);
  const lastPart = url.substring(url.length - 10);
  return `${firstPart}...${lastPart}`;
};

export const MessageText = ({ text }: { text: string }) => {
  const parts = text.split(getUrlRegex());

  return (
    <>
      {parts.map((part, index) =>
        getUrlRegex().test(part) ? (
          <Text
            key={index}
            style={{
              textDecorationLine: 'underline',
            }}
            onPress={() => Linking.openURL(part)}
          >
            {formatUrl(part)}
          </Text>
        ) : (
          <Text key={index} style={[]} selectable={true}>
            {part}
          </Text>
        )
      )}
    </>
  );
};

export const MessageContent: React.FC<Props> = ({ message, styles }) => {
  const { downloadFile, getImageUrlFromMessage } = useGptConversationContext();
  const imageUrl = getImageUrlFromMessage(message);
  if (imageUrl) {
    return (
      <TouchableOpacity
        onPress={() => {
          downloadFile(message as MessageFile);
        }}
        style={{
          height: Dimensions.get('window').width * 0.8,
        }}
      >
        <Image
          nativeID={`image-${message.id}`}
          source={{ uri: imageUrl }}
          resizeMode="contain"
          style={{
            width: '100%',
            height: '100%',
            flex: 1,
          }}
        />
      </TouchableOpacity>
    );
  }
  return (
    <Text
      key={message.id}
      style={[
        styles.text,
        message.messageType === 'url' ? styles.url : {},
        message.messageType === 'file' ? styles.file : {},
      ]}
      onPress={() => {
        if (message.messageType === 'url' && message.attachments.url) {
          Linking.openURL(message.attachments.url);
          return;
        }
        if (message.messageType === 'file') {
          downloadFile(message);
          return;
        }
      }}
      selectable={true}
    >
      <MessageText text={message.message} />
    </Text>
  );
};
